"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitIntoBatches = exports.removeEmptyValues = exports.parseDbPgIdPointer = exports.parseDbPgColumnPointer = exports.parseDbS3IdentifierPointer = exports.numberCoordsToExcelCoords = exports.numberWithCommasAndDecimals = exports.numberWithCommas = exports.numberToFormattedString = exports.numberToExcelLetter = exports.maskInfo = exports.jsRound = exports.isValidSnakeCase = exports.isSubset = exports.isProperExcelCoords = exports.isNumericString = exports.isFinleyTestUserEmail = exports.getTotalBorrowingBaseCashContribution = exports.getReportingDate = exports.getFileVersion = exports.getFileNameFromS3Path = exports.generateS3Identifier = exports.generateFlattenNestedKeyObject = exports.excelCoordsToNumberCoords = exports.divideByOrZero = exports.flatToNestedJson = exports.cleanStrForDb = exports.calculateWeightedAverage = exports.borrowingBaseContributionAccountBalancesFromBankAccountCashBalances = exports.byteFormatter = exports.base64Decode = exports.base64Encode = exports.average = exports.arraysContainSameValues = exports.flags = exports.convertMsToHmsString = exports.generatePgIdentifier = exports.toFullyTrimmedString = exports.toInitialCase = exports.toTitleCase = exports.toSentenceCase = exports.RandomStringUtils = exports.truncateUrlProtocol = exports.numberToCurrencyWithSymbol = exports.getCurrencySymbol = exports.numberToDollarFormattedRounded = exports.uuidRegex = exports.EnvUtils = exports.BigMap = exports.BigSet = void 0;
exports.solveKnapsackBruteForce = exports.sortTopologically = exports.retry = exports.sleep = exports.exponentialBackoff = exports.truncateUuid = exports.substituteDeepPaths = exports.stripDbTimeStamps = void 0;
exports.andThen = andThen;
exports.ensure = ensure;
/* eslint-disable camelcase */
const edit_1 = __importDefault(require("@sheet/edit"));
const accounting_1 = __importDefault(require("accounting"));
const _ = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const commonConsts = __importStar(require("../consts"));
const error_1 = require("../error");
const commonTypeguards = __importStar(require("../typeguards"));
const base64_1 = require("./base64");
Object.defineProperty(exports, "base64Encode", { enumerable: true, get: function () { return base64_1.base64Encode; } });
Object.defineProperty(exports, "base64Decode", { enumerable: true, get: function () { return base64_1.base64Decode; } });
const concurrency_1 = require("./concurrency");
Object.defineProperty(exports, "exponentialBackoff", { enumerable: true, get: function () { return concurrency_1.exponentialBackoff; } });
Object.defineProperty(exports, "sleep", { enumerable: true, get: function () { return concurrency_1.sleep; } });
Object.defineProperty(exports, "retry", { enumerable: true, get: function () { return concurrency_1.retry; } });
const flatToNestedJson_1 = require("./flatToNestedJson");
Object.defineProperty(exports, "flatToNestedJson", { enumerable: true, get: function () { return flatToNestedJson_1.flatToNestedJson; } });
const generateFlattenNestedKeyObject_1 = require("./generateFlattenNestedKeyObject");
Object.defineProperty(exports, "generateFlattenNestedKeyObject", { enumerable: true, get: function () { return generateFlattenNestedKeyObject_1.generateFlattenNestedKeyObject; } });
const jsonSubstitute_1 = require("./jsonSubstitute");
Object.defineProperty(exports, "substituteDeepPaths", { enumerable: true, get: function () { return jsonSubstitute_1.substituteDeepPaths; } });
const knapsack_1 = require("./knapsack");
Object.defineProperty(exports, "solveKnapsackBruteForce", { enumerable: true, get: function () { return knapsack_1.solveKnapsackBruteForce; } });
const topologicalSort_1 = require("./topologicalSort");
Object.defineProperty(exports, "sortTopologically", { enumerable: true, get: function () { return topologicalSort_1.sortTopologically; } });
const { formatMoney } = accounting_1.default;
var bigSet_1 = require("./data/bigSet");
Object.defineProperty(exports, "BigSet", { enumerable: true, get: function () { return bigSet_1.BigSet; } });
var bigMap_1 = require("./data/bigMap");
Object.defineProperty(exports, "BigMap", { enumerable: true, get: function () { return bigMap_1.BigMap; } });
var EnvUtils;
(function (EnvUtils) {
    // We should only use this method within this namespace.
    // Use `getEnv()` method instead, which will check `env` validity using this particular method.
    const isValidEnv = (val) => {
        return finley_types_1.nodeEnvs.includes(val) || val === 'test';
    };
    // NOTE:
    // This is probably the ugliest thing I've done in a while.
    // I'm basically creating "env" variable precedence, where NODE_ENV -> deployEnv -> `default`.
    // I really have very little idea, if this will break things at this time.
    // TODO:
    // Simply put, having multiple ENV variable is just bad ju-ju.  We need to consolidate the ENV variable asap
    EnvUtils.getEnv = () => {
        const env = process.env.NODE_ENV ||
            process.env.deployEnv || // TODO: this ref should be removed, but for now it should be the only place that should access/read deployEnv
            'development';
        (0, error_1.finleyAssert)(isValidEnv(env), 'env must be valid');
        return env;
    };
    EnvUtils.isSandboxMode = () => {
        // See difference between `schema` and `sandboxSchema` in the finleydb package. Sandbox mode is
        // orthogonal to deploy environment.
        return Boolean(process.env.IS_SANDBOX_MODE);
    };
    // This is a terrible workaround. Don't use this!
    EnvUtils.isBackend = () => typeof window === 'undefined' || typeof window.document === 'undefined';
    EnvUtils.isCustomerFacing = () => {
        const env = EnvUtils.getEnv();
        return env === 'prod' || env === 'client' || env === 'client-uat';
    };
    EnvUtils.isDevelopment = () => {
        return EnvUtils.getEnv() === 'development';
    };
    EnvUtils.isStage = () => {
        return EnvUtils.getEnv() === 'stage';
    };
    EnvUtils.isNotDevelopment = () => {
        return EnvUtils.getEnv() !== 'development';
    };
    EnvUtils.isClientUat = () => {
        const env = EnvUtils.getEnv();
        return env === 'client-uat';
    };
    EnvUtils.isClientOrClientUat = () => {
        const env = EnvUtils.getEnv();
        return env === 'client' || env === 'client-uat';
    };
    EnvUtils.getTellerEnv = (organizationSlug) => {
        const demoAccountsOrgSlugs = new Set([
            'acmeCorp',
            'abcProviders',
            'coitTowerTechnologies',
            'embarcaderoTechnologies',
            'mintPlazaBank',
            'presidioCorp',
        ]);
        // always use teller sandbox env for Finley's demo organizations
        if (demoAccountsOrgSlugs.has(organizationSlug)) {
            return 'sandbox';
        }
        const tellerEnvironment = EnvUtils.isCustomerFacing()
            ? 'development'
            : 'sandbox'; // 'development' is Teller's prod environment for 100 connected accounts
        return tellerEnvironment;
    };
})(EnvUtils || (exports.EnvUtils = EnvUtils = {}));
// https://stackoverflow.com/questions/6229197/how-to-know-if-two-arrays-have-the-same-values
const arraysContainSameValues = ({ array1, array2, }) => _.isEmpty(_.xor(array1, array2));
exports.arraysContainSameValues = arraysContainSameValues;
/**
 * determines if the "test" array is a subset of the "superset" array
 */
const isSubset = ({ test, superset, }) => {
    const set = new Set(superset);
    return _.every(test, (el) => set.has(el));
};
exports.isSubset = isSubset;
/**
 * Convert a number to one with commas, e.g. 12345 => 12,345
 * @param number number, can be either string or number
 */
const numberWithCommas = (number) => {
    if (_.isNil(number)) {
        return number;
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.numberWithCommas = numberWithCommas;
/**
 * Convert a number to one with commas while retaining x decimal points, e.g. 12345.1234 => 12,345.12
 * @param number number, must be number type
 * @param decimalPoints number of decimal points retained, defaults to 2
 */
const numberWithCommasAndDecimals = (number, decimalPoints) => {
    if (_.isNil(number)) {
        return number;
    }
    return number
        .toFixed(decimalPoints || 2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.numberWithCommasAndDecimals = numberWithCommasAndDecimals;
/**
 * Removes the newline carriages from a string (\n or \n\r)
 * https://kb.tableau.com/articles/issue/error-invalid-input-syntax-for-type-date-error-while-executing-the-query
 * empty strings need to be null for e.g. `Date` property types
 * Object.keys returns string[] and needs to cast to any: https://github.com/microsoft/TypeScript/pull/12253
 * @param text string to clean for DB
 */
const cleanStrForDb = (text) => {
    if (typeof text !== 'string') {
        return text;
    }
    if (typeof text === 'boolean') {
        return text;
    }
    if (text === '') {
        return null;
    }
    return text.replace(/\r?\n|\r/g, '').trim();
};
exports.cleanStrForDb = cleanStrForDb;
const stripDbTimeStamps = (obj) => {
    const { created_at: _strippedCreatedAt, updated_at: _strippedUpdatedAt, ...rest } = obj;
    return rest;
};
exports.stripDbTimeStamps = stripDbTimeStamps;
exports.uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
/**
 * Helper method to get the fileName from a given s3 path
 * @param s3Path e.g. even/borrowing-base-certificate-2021-06-14.pdf
 * @returns borrowing-base-certificate-2021-06-14.pdf
 */
const getFileNameFromS3Path = (s3Path) => {
    if (!s3Path) {
        return '';
    }
    return _.last(s3Path.split('/')) || '';
};
exports.getFileNameFromS3Path = getFileNameFromS3Path;
const divideByOrZero = (numerator, denominator) => {
    if (denominator === 0) {
        return 0;
    }
    return _.divide(numerator, denominator);
};
exports.divideByOrZero = divideByOrZero;
/**
 * Masks string by leaving `nChar` characters unchanged on the tail
 */
const maskInfo = (val, nChar = 4) => {
    (0, error_1.finleyAssert)(val.length >= nChar, 'Please specify fewer nChar value than the length of string');
    return `****${val.substr(val.length - nChar)}`;
};
exports.maskInfo = maskInfo;
/**
 * Convert a number to one that's formatted, e.g. 20000 => $20K and 5000000 to $5M
 * @param number number to be formatted
 */
const numberToDollarFormattedRounded = (number) => {
    if (_.isNil(number)) {
        return number;
    }
    if (number >= 1000000000) {
        return `$${(number / 1000000000).toFixed(1).replace(/\.0$/, '')}B`;
    }
    if (number >= 1000000) {
        return `$${(number / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (number >= 1000) {
        return `$${(number / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    }
    return `$${number.toFixed(2)}`;
};
exports.numberToDollarFormattedRounded = numberToDollarFormattedRounded;
// !TODO @eldarshamukhamedov Move to client
const getCurrencySymbol = (currency) => {
    const currencySymbolConfig = {
        USD: '$',
        CAD: '$',
        MXN: '$',
        EUR: '€',
        GBP: '£',
    };
    return currencySymbolConfig[currency] || '';
};
exports.getCurrencySymbol = getCurrencySymbol;
/**
 * Convert a number to currency string with custom symbol and format using the accounting.js module
 * @param param0 format: %v = value, %s = symbol
 * style: symbol (eg. $) -> `$1,000.00` || code (eg. USD) -> `$1,000.00 USD`
 * @returns
 */
const numberToCurrencyWithSymbol = ({ number, currency = finley_types_1.Bank.Currency.USD, style = 'symbol', format = '%s%v', }) => {
    if (_.isNil(number)) {
        return number;
    }
    const formattedCurrency = formatMoney(number, {
        symbol: style === 'code' ? currency : (0, exports.getCurrencySymbol)(currency),
        format,
    });
    return style === 'code'
        ? `${(0, exports.getCurrencySymbol)(currency)}${formattedCurrency}`
        : formattedCurrency;
};
exports.numberToCurrencyWithSymbol = numberToCurrencyWithSymbol;
const numberToFormattedString = (value, format, isDelta, roundingPrecision = 2) => {
    const valueWithCurrencyRounding = (0, exports.numberToDollarFormattedRounded)(value);
    const valueWithPercentageMultiplier = (value * 100).toFixed(roundingPrecision);
    switch (format) {
        case 'currency':
            if (value > 0) {
                return isDelta
                    ? `+${valueWithCurrencyRounding}`
                    : `${valueWithCurrencyRounding}`;
            }
            if (value === 0) {
                return `${valueWithCurrencyRounding}`;
            }
            if (value < 0) {
                return `-${(0, exports.numberToDollarFormattedRounded)(Math.abs(value))}`;
            }
            break;
        case 'percentage':
            if (value > 0) {
                return isDelta
                    ? `+${valueWithPercentageMultiplier}%`
                    : `${valueWithPercentageMultiplier}%`;
            }
            if (value <= 0) {
                return `${valueWithPercentageMultiplier}%`;
            }
            break;
        default:
            return `${value}`;
    }
    return `${value}`;
};
exports.numberToFormattedString = numberToFormattedString;
// To avoid rounding, set `roundingPrecision` option to null
const calculateWeightedAverage = (dataArray, options) => {
    let numerator = 0;
    let denominator = 0;
    for (const { value, weight } of dataArray) {
        numerator += value * weight;
        denominator += weight;
    }
    if (options.roundingPrecision === null) {
        return divideByOrZero(numerator, denominator);
    }
    return _.round(divideByOrZero(numerator, denominator), options.roundingPrecision);
};
exports.calculateWeightedAverage = calculateWeightedAverage;
/**
 * averages a list of numbers
 */
const average = (nums) => {
    return divideByOrZero(_.sum(nums), nums.length);
};
exports.average = average;
/**
 * Truncates `protocol` portion of URL string.
 * url format may look like:
 * https://..., sftp://..., redis://..., or even //...
 */
const truncateUrlProtocol = (url) => {
    return url.replace(/(^\w+:|^)\/\//, '');
};
exports.truncateUrlProtocol = truncateUrlProtocol;
/**
 * Get the reportingDate in `YYYY-MM-DD` of an uploaded CSV tape(e.g. servicing-tape-2021-07-01.csv will give you `2021-07-01` reporting date)
 * @param fileName e.g. servicing-tape-2021-07-01-v3.csv
 * @returns the `YYYY-MM-DD` reportingDate of that file, e.g. '2021-07-01'
 */
const getReportingDate = (fileName) => {
    // we should never fail to get the reporting date if we aligned on
    // if it passes this regex, we can typecast to Util.FullDateStr
    const reportingDateMatch = fileName && fileName.match(/(202[\d]{1}-[\d]{2}-[\d]{2})/);
    if (_.isNil(reportingDateMatch) || reportingDateMatch === '') {
        throw new Error(`Failed to receive reporting date from the fileName: ${fileName}`);
    }
    const [, reportingDate] = reportingDateMatch;
    return reportingDate;
};
exports.getReportingDate = getReportingDate;
/**
 * Get the version of an uploaded CSV tape, defaults to `1` for a file without a version appended (e.g. servicing-tape-2021-07-01.csv)
 * Note: v0 will be treated as file version 0, and nothing appended will be treated as file version 1
 * e.g. `repayment-tape.csv` will be v1 and `repayment-tape-v0.csv` will be v0
 * @param fileName e.g. servicing-tape-2021-07-01-v3.csv
 * @returns the `number` version of that file, e.g. 2
 */
const getFileVersion = (fileName) => {
    // returns group catcher on \.match for only single match (no g flag)
    const versionNumber = fileName && fileName.match(/-v(\d+)/);
    let fileVersion;
    if (versionNumber) {
        fileVersion = Number(versionNumber[1]);
    }
    if (_.isNil(fileVersion)) {
        return { fileVersion: 1, foundVersion: false };
    }
    return { fileVersion, foundVersion: true };
};
exports.getFileVersion = getFileVersion;
const isNumericString = (str) => {
    if (typeof str !== 'string' || str === '')
        return false; // we only process non-empty strings!
    // just check for number conversion
    // because  2.9577063472290262e-15 is a  number
    const number = Number(str);
    return !Number.isNaN(number) && Number.isFinite(number);
};
exports.isNumericString = isNumericString;
var RandomStringUtils;
(function (RandomStringUtils) {
    RandomStringUtils.AlphaCharset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    RandomStringUtils.NumericCharset = '0123456789';
    RandomStringUtils.AlphaNumCharset = RandomStringUtils.AlphaCharset + RandomStringUtils.NumericCharset;
    RandomStringUtils.generateRandomString = (len, charset = RandomStringUtils.AlphaNumCharset) => {
        /* eslint-disable no-restricted-syntax, no-plusplus */
        let randStr = '';
        for (let iter = len; iter > 0; --iter)
            randStr += charset[Math.floor(Math.random() * charset.length)];
        return randStr;
        /* eslint-enable no-restricted-syntax, no-plusplus */
    };
})(RandomStringUtils || (exports.RandomStringUtils = RandomStringUtils = {}));
const removeEmptyValues = (obj) => {
    return _.pickBy(obj, (val) => val !== undefined);
};
exports.removeEmptyValues = removeEmptyValues;
// Transforms strings to sentence case
const toSentenceCase = (str) => _.upperFirst(_.lowerCase(str));
exports.toSentenceCase = toSentenceCase;
// Transforms string to space separated words, where each word starts with an upper case character
const toTitleCase = (text) => _.startCase(_.camelCase(text));
exports.toTitleCase = toTitleCase;
// Transforms string to initial case, where the FirstLetterIsCapitalized
const toInitialCase = (text) => _.upperFirst(_.camelCase(text));
exports.toInitialCase = toInitialCase;
const toFullyTrimmedString = (text) => {
    return text.replace(/\s+/g, ' ').trim();
};
exports.toFullyTrimmedString = toFullyTrimmedString;
const borrowingBaseContributionAccountBalancesFromBankAccountCashBalances = (bankAccountCashBalances, defaultValue = 0) => {
    // Iterate through cash balances once and generate total sum per account
    const accounts = _.reduce(bankAccountCashBalances, (result, account) => {
        (0, error_1.finleyAssert)(commonTypeguards.isBorrowerBankAccountType(account.accountType), new error_1.FinleyError('borrowingBaseContributionAccountBalancesFromCashResponseTape: account must be a borrower account type', { metadata: { logMeta: { account, bankAccountCashBalances } } }));
        const oldTotal = result[account.accountType] || 0;
        const accountBalance = account.balance ? account.balance : defaultValue;
        // eslint-disable-next-line no-param-reassign
        result[account.accountType] = oldTotal + accountBalance;
        return result;
    }, {});
    // Iterate through contribution account types and return previously calculated sum or 0
    return _.reduce(commonConsts.borrowingBaseContributionAccountTypes, (result, accountType) => {
        // eslint-disable-next-line no-param-reassign
        result[accountType] = accounts[accountType] || 0;
        return result;
    }, {});
};
exports.borrowingBaseContributionAccountBalancesFromBankAccountCashBalances = borrowingBaseContributionAccountBalancesFromBankAccountCashBalances;
const getTotalBorrowingBaseCashContribution = (bankAccountCashBalances, defaultValue = 0) => {
    const accountBalances = borrowingBaseContributionAccountBalancesFromBankAccountCashBalances(bankAccountCashBalances, defaultValue);
    return _.sum(_.values(accountBalances));
};
exports.getTotalBorrowingBaseCashContribution = getTotalBorrowingBaseCashContribution;
const numberToExcelLetter = (num) => {
    return edit_1.default.utils.encode_col(num);
};
exports.numberToExcelLetter = numberToExcelLetter;
const numberCoordsToExcelCoords = (coords) => {
    return edit_1.default.utils.encode_cell(coords);
};
exports.numberCoordsToExcelCoords = numberCoordsToExcelCoords;
const excelCoordsToNumberCoords = (excelCoords) => {
    return edit_1.default.utils.decode_cell(excelCoords);
};
exports.excelCoordsToNumberCoords = excelCoordsToNumberCoords;
const EXCEL_CORDS_REGEX = /^[A-Z]+[1-9][0-9]*$/;
const isProperExcelCoords = (excelCoords) => {
    return EXCEL_CORDS_REGEX.test(excelCoords);
};
exports.isProperExcelCoords = isProperExcelCoords;
/**
 * helper method for async methods within pipes
 * https://github.com/remeda/remeda/issues/97
 */
function andThen(fn) {
    return async (a) => {
        return fn(await a);
    };
}
function ensure(argument, message = 'This value was ensured to exist!!!') {
    if (argument === undefined || argument === null) {
        throw new TypeError(message);
    }
    return argument;
}
/**
 * Splits an array into individual arrays with maximum length of batch size
 */
const splitIntoBatches = (elements, batchSize = 5000) => {
    const batches = [];
    // eslint-disable-next-line no-restricted-syntax
    for (let idx = 0; idx < elements.length; idx += batchSize) {
        // JS handles overrunning the array length, so this is safe
        batches.push(elements.slice(idx, idx + batchSize));
    }
    return batches;
};
exports.splitIntoBatches = splitIntoBatches;
const generateS3Identifier = (s3Path) => {
    (0, error_1.finleyAssert)(s3Path !== '', 'Can not create S3 identifier with empty path');
    return `${commonConsts.S3_PATH_MARKER}${s3Path}`;
};
exports.generateS3Identifier = generateS3Identifier;
const generatePgIdentifier = ({ column, id, }) => `${commonConsts.POSTGRES_COLUMN_MARKER}${column}${commonConsts.POSTGRES_ID_MARKER}${id}`;
exports.generatePgIdentifier = generatePgIdentifier;
/**
 * Extract S3 path from identifier pattern for S3 used in our PG DB.
 * Note that this returns "null" for empty strings since not usable s3Path
 */
const parseDbS3IdentifierPointer = (identifier) => {
    const match = identifier.match(commonConsts.S3_IDENTIFIER_REGEX);
    if (!match || match.length !== 2) {
        return null;
    }
    return match[1] || null;
};
exports.parseDbS3IdentifierPointer = parseDbS3IdentifierPointer;
const parseDbPgColumnPointer = (identifier) => {
    const match = identifier.match(commonConsts.PG_COLUMN_IDENTIFIER_REGEX);
    if (!match)
        return null;
    if (match.length !== 2)
        return null;
    return match[1];
};
exports.parseDbPgColumnPointer = parseDbPgColumnPointer;
const parseDbPgIdPointer = (identifier) => {
    const match = identifier.match(commonConsts.PG_ID_IDENTIFIER_REGEX);
    if (!match)
        return null;
    if (match.length !== 2)
        return null;
    return match[1];
};
exports.parseDbPgIdPointer = parseDbPgIdPointer;
const isValidSnakeCase = (str) => {
    if (!str) {
        return false;
    }
    // While "snakeCase" convention technically doesn't require first
    // char to be a letter, we typically expect and operate off of this
    // within Finley domain.
    // Can revisit this if we need to loosen this restriction
    const isFirstCharLetter = str[0].match(/[a-z]/i);
    if (!isFirstCharLetter) {
        return false;
    }
    return str === _.snakeCase(str);
};
exports.isValidSnakeCase = isValidSnakeCase;
const byteFormatter = (rawBytes) => {
    const prefix = rawBytes < 0 ? '-' : '';
    const bytes = Math.abs(rawBytes);
    let formatted;
    if (bytes < 1024) {
        formatted = `${bytes} B`;
    }
    else if (bytes < 1024 * 1024) {
        formatted = `${(bytes / 1024).toFixed(2)} KB`;
    }
    else if (bytes < 1024 * 1024 * 1024) {
        formatted = `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }
    else {
        formatted = `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
    return `${prefix}${formatted}`;
};
exports.byteFormatter = byteFormatter;
const isFinleyTestUserEmailRegex = /^test.*@finleycms\.com$/;
const isFinleyTestUserEmail = (email) => {
    return isFinleyTestUserEmailRegex.test(email);
};
exports.isFinleyTestUserEmail = isFinleyTestUserEmail;
/**
 * Returns MS duration input in "h:m:s" string format.
 * Defaults negative value to 0 time output. Can revisit this if
 * we prefer different output for this case
 */
const convertMsToHmsString = (duration) => {
    if (duration < 0) {
        return '0m:0s';
    }
    const hours = Math.floor(duration / 3600000);
    const minutes = Math.floor((duration % 3600000) / 60000);
    const seconds = Math.floor((duration % 60000) / 1000);
    if (hours !== 0) {
        return `${hours}h:${minutes}m:${seconds}s`;
    }
    return `${minutes}m:${seconds}s`;
};
exports.convertMsToHmsString = convertMsToHmsString;
// Helper to address JS math floating point issues depending on required precision
const jsRound = ({ value, precision, mode = 'standard', }) => {
    switch (mode) {
        case 'standard':
            return Math.round(value * 10 ** precision) / 10 ** precision;
        case 'ceiling':
            return Math.ceil(value * 10 ** precision) / 10 ** precision;
        case 'floor':
            return Math.floor(value * 10 ** precision) / 10 ** precision;
        default:
            return (0, error_1.finleyAssertUnreachable)(mode);
    }
};
exports.jsRound = jsRound;
const flags = {
    // NOTE: to help control Admin Agent fronting functionality.
    // Currently only Valley SLS uses our loans flow and requires Admin Agent
    // fronting so fully enabled now. Can adjust to make this dynamic as needed.
    isAdminAgentFrontingEnabled: EnvUtils.isDevelopment() ||
        EnvUtils.isStage() ||
        EnvUtils.isCustomerFacing(),
};
exports.flags = flags;
const truncateUuid = (uuid) => {
    if (uuid.length <= 12) {
        return uuid.toUpperCase();
    }
    return `...${uuid.slice(-12).toUpperCase()}`;
};
exports.truncateUuid = truncateUuid;
//# sourceMappingURL=index.js.map